import actionCreatorFactory from "typescript-fsa";

const create = actionCreatorFactory("TogglePolling");

export const togglePolling = create<boolean>("TOGGLE_POLLING");



// WEBPACK FOOTER //
// ./src/polling/actions.ts